export enum CreditPullTypes {
	ORIGINAL = 1,
	COURTESY_REPULL = 2
}

export enum AnnualReviewStatusTypes {
	BATCHED = 1,
	CREDIT_PULLED = 2,
	DECISION_ERROR = 3,
	CREDIT_ALERT = 4,
	INITIALLY_PASSED = 5,
	INITIALLY_FAILED = 6,
	APPROVED = 7,
	DECLINED = 8
}

export interface StatusTypeOption {
  name: string;
  value: AnnualReviewStatusTypes;
}

export const AnnualReviewStatusOptionsLookup: Record<AnnualReviewStatusTypes, StatusTypeOption> = {
	[AnnualReviewStatusTypes.BATCHED]: { name: 'Batched Review', value: AnnualReviewStatusTypes.BATCHED },
	[AnnualReviewStatusTypes.CREDIT_PULLED]: { name: 'Credit Pulled', value: AnnualReviewStatusTypes.CREDIT_PULLED },
	[AnnualReviewStatusTypes.DECISION_ERROR]: { name: 'Decision Error', value: AnnualReviewStatusTypes.DECISION_ERROR },
	[AnnualReviewStatusTypes.CREDIT_ALERT]: { name: 'AR Credit Alert', value: AnnualReviewStatusTypes.CREDIT_ALERT },
	[AnnualReviewStatusTypes.INITIALLY_PASSED]: { name: 'Initially Passed', value: AnnualReviewStatusTypes.INITIALLY_PASSED },
	[AnnualReviewStatusTypes.INITIALLY_FAILED]: { name: 'Initially Failed', value: AnnualReviewStatusTypes.INITIALLY_FAILED },
	[AnnualReviewStatusTypes.APPROVED]: { name: 'AR Approved', value: AnnualReviewStatusTypes.APPROVED },
	[AnnualReviewStatusTypes.DECLINED]: { name: 'AR Declined', value: AnnualReviewStatusTypes.DECLINED }
};